var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_setup.dataHasLoaded)?_c('div',{staticClass:"post-new-form justify-center"},[_c(_setup.HandleForm,{attrs:{"parentData":_setup.parentData},on:{"close-form":_setup.closeForm}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }